export default function BlueprintPreviewCard() {
  return (
    <div className="overflow-hidden rounded-2xl border border-border/60 bg-background/80">
      <div className="border-b border-border/60 px-4 py-3 sm:px-5">
        <p className="text-sm font-semibold text-foreground">Example Blueprint</p>
        <p className="mt-1 text-sm text-muted-foreground">
          A visual example of how MapleOS AI Blueprints connect context, decisions, and actions.
        </p>
      </div>

      <div className="bg-black">
        <img
          src="/images/mapleos/blueprints/oncology-research-flow.png"
          alt="MapleOS AI Blueprint showing an oncology research flow with connected steps and actions"
          className="h-auto w-full object-cover"
          loading="lazy"
        />
      </div>
    </div>
  );
}
